export const termsOfServiceRoutesNames = {
  TERMS_OF_SERVICE: 'tos',
};
